"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BlobHandler = void 0;
const ChainRequest_1 = require("../chain/ChainRequest");
const TransformServiceHandlerChain_1 = require("../chain/TransformServiceHandlerChain");
const mime_db_1 = __importDefault(require("mime-db"));
const CustomApiTransformUtil_1 = require("../util/CustomApiTransformUtil");
const GenUtil_1 = require("../../../../cutil/GenUtil");
const CustomApiTransformError_1 = require("../error/CustomApiTransformError");
const JsonUtil_1 = require("../../../../cutil/JsonUtil");
class BlobHandler extends TransformServiceHandlerChain_1.Handler {
    constructor(brainClient) {
        super();
        this.brainClient = brainClient;
    }
    async process(request) {
        const displayType = request.displayType;
        /// 只处理 upload file type
        if (!CustomApiTransformUtil_1.CustomApiTransformUtil.isUploadFileType(displayType)) {
            return false;
        }
        const blob = await CustomApiTransformUtil_1.CustomApiTransformUtil.fetchBlob(request);
        if (!blob) {
            /// 如果是文件类型，但是不能回去文件类容
            throw CustomApiTransformError_1.CustomApiTransformError.default;
        }
        // socket 会来多次，如果是一个substory，那么无法将progress的UI通知出去，所以不需要每次都上传文件
        // 否则会有多次studio api的调用
        if (!request.isEnded && request.websocketHtml) {
            const initCreateBlobUrl = JsonUtil_1.JsonUtil.toModelFromInstance(new ChainRequest_1.ChainResultInitCreateBlobUrl(), {
                objectURL: URL.createObjectURL(blob),
                loading: false,
                streaming: true,
            });
            const textAreaValue = JsonUtil_1.JsonUtil.toModelFromInstance(new ChainRequest_1.ChainResultTextAreaValue(), {
                value: "",
                loading: false,
                s3Url: "",
                s3Path: "",
                needToCreateBlobUrl: "",
                uuid: "",
                name: "",
                format: "",
            });
            request.setResult({ initCreateBlobUrl, textAreaValue, displayType: displayType });
            return true;
        }
        const data = new FormData();
        data.append("file", blob);
        const res = await this.brainClient.openAi.upload(data);
        const s3Url = res?.data?.object_s3_url || res?.data?.s3_https_url || "";
        const uuid = res?.data?.uuid;
        const { name, format } = this.generateFilename(request.contentType);
        const initCreateBlobUrl = JsonUtil_1.JsonUtil.toModelFromInstance(new ChainRequest_1.ChainResultInitCreateBlobUrl(), {
            objectURL: URL.createObjectURL(blob),
            loading: false,
            streaming: false,
        });
        const textAreaValue = JsonUtil_1.JsonUtil.toModelFromInstance(new ChainRequest_1.ChainResultTextAreaValue(), {
            loading: false,
            s3Url,
            s3Path: res?.data?.object_key,
            needToCreateBlobUrl: `/api/me/upload/studios?url=${encodeURIComponent(s3Url)}`,
            uuid,
            name,
            format,
            value: s3Url,
        });
        request.setResult({ initCreateBlobUrl, textAreaValue, displayType: displayType });
        return true;
    }
    generateFilename(contentType) {
        const types = contentType?.split(";") || [];
        let comfirmedType = undefined;
        for (const type of types) {
            for (const [key, _displayType] of CustomApiTransformUtil_1.CustomApiTransformUtil.mimeTypesMap) {
                const regex = new RegExp(`^${key}`);
                if (regex.test(type.trim())) {
                    comfirmedType = type;
                }
            }
        }
        const extensions = mime_db_1.default[comfirmedType || "text/html"].extensions;
        const fileExtension = Array.from(extensions || []).first() || "html";
        return { name: GenUtil_1.GenUtil.randomString() + "." + fileExtension, format: fileExtension };
    }
}
exports.BlobHandler = BlobHandler;
